import React, { useEffect, useState } from 'react';

/** Live mm:ss timer counting up from `since` (Date.now() epoch ms). */
export const CallTimer: React.FC<{ since?: number; className?: string }> = ({ since, className }) => {
  const [, tick] = useState(0);
  useEffect(() => {
    if (!since) return;
    const t = window.setInterval(() => tick(n => n + 1), 1000);
    return () => window.clearInterval(t);
  }, [since]);

  if (!since) return null;
  const secs = Math.max(0, Math.floor((Date.now() - since) / 1000));
  const mm = String(Math.floor(secs / 60)).padStart(2, '0');
  const ss = String(secs % 60).padStart(2, '0');
  return <span className={className}>{mm}:{ss}</span>;
};
